import { render, staticRenderFns } from "./shipmentStaffEdit.vue?vue&type=template&id=59f6d7d2&scoped=true"
import script from "./shipmentStaffEdit.vue?vue&type=script&lang=js"
export * from "./shipmentStaffEdit.vue?vue&type=script&lang=js"
import style0 from "./shipmentStaffEdit.vue?vue&type=style&index=0&id=59f6d7d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f6d7d2",
  null
  
)

export default component.exports